import { render, staticRenderFns } from "./DescuentoButacas.vue?vue&type=template&id=2733e8ee"
import script from "./DescuentoButacas.vue?vue&type=script&lang=js"
export * from "./DescuentoButacas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports